import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, NavLink, Navigate } from "react-router-dom";
import "./styles.css";
import { ToastContainer, CommandPalette } from "./components";
import App from "./App";
import DashboardPage from "./pages/DashboardPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import ProductsPage from "./pages/ProductsPage";
import InventoryPage from "./pages/InventoryPage";
import SalesHistoryPage from "./pages/SalesHistoryPage";
import LoginPage from "./pages/LoginPage";
import TaxReportPage from "./pages/TaxReportPage";
import ImportOrderPage from "./pages/ImportOrderPage";
import ImportVnPage from "./pages/ImportVnPage";
import VirtualInventoryPage from "./pages/VirtualInventoryPage";
import PayablesPage from "./pages/PayablesPage";
import ExpensesPage from "./pages/ExpensesPage";
import StockTakePage from "./pages/StockTakePage";
const BarcodePrintPage = React.lazy(() => import("./pages/BarcodePrintPage"));
const PosPage = React.lazy(() => import("./pages/PosPage"));
import AdminToolsPage from "./pages/AdminToolsPage";
import PurchaseLedgerPage from "./pages/PurchaseLedgerPage";
import PnLReportPage from "./pages/PnLReportPage";
import NeedsCompletionPage from "./pages/NeedsCompletionPage";
import ConsignmentPage from "./pages/ConsignmentPage";
import BackupPage from "./pages/BackupPage";
import AssetsPage from "./pages/AssetsPage";
import BackfillPage from "./pages/BackfillPage";
import InventoryAllocationPage from "./pages/InventoryAllocationPage";
import StockAlertsPage from "./pages/StockAlertsPage";
import ABCAnalysisPage from "./pages/ABCAnalysisPage";
import PredictiveRestockPage from "./pages/PredictiveRestockPage";
import SuppliersPage from "./pages/SuppliersPage";
import AIConfigPage from "./pages/AIConfigPage";
import TaxCenterPage from "./pages/TaxCenterPage";
import MaterialsPage from "./pages/MaterialsPage";
import BankNotificationsPage from "./pages/BankNotificationsPage";

const tg = (window as any).Telegram?.WebApp;
if (tg) {
  tg.ready();
  tg.expand();
  tg.disableVerticalSwipes?.(); // Prevent Telegram swipe-down from intercepting touch on topbar
  tg.setHeaderColor?.("#000000");
  tg.setBackgroundColor?.("#000000");
}

// Auto-update SW: controllerchange → reload NGAY (k chờ user bấm banner).
// Telegram WebApp k navigate → k tự check SW update → poll mỗi 30s khi tab focus.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => r.update());
  });
  // Khi SW mới activate → reload ngay (bản mới đã skipWaiting)
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    try { window.location.reload(); } catch {}
  });
  // Poll update mỗi 30s (đánh thức SW check byte thay đổi)
  setInterval(() => {
    if (document.visibilityState === 'visible') {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.update());
      });
    }
  }, 30000);
}

// Nút "Cập nhật" manual — Telegram WebApp cache cứng, SW lifecycle k đáng tin.
// Bấm → unregister SW + reload với cache-bust (?v=ts) → ép load bản mới.
(function setupForceUpdateButton() {
  const btn = document.createElement('button');
  btn.id = 'force-update-btn';
  btn.className = 'icon-btn update-btn';
  btn.title = 'Cập nhật bản mới';
  btn.innerHTML = '<span class="material-symbols-outlined">refresh</span><span style="position:absolute;top:2px;right:2px;width:8px;height:8px;background:#34d399;border-radius:50%;border:2px solid var(--bg-elev,#1e1e22);"></span>';
  btn.style.cssText = 'position:relative;display:inline-flex;';
  btn.onclick = async () => {
    btn.textContent = '⏳';
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch {}
    const url = new URL(window.location.href);
    url.searchParams.set('v', String(Date.now()));
    window.location.replace(url.toString());
  };
  // Gắn nút vào top-actions của topbar nếu có — bấm được cả mobile + web, k che content.
  const mount = () => {
    const ta = document.querySelector('.top-actions');
    if (ta && !ta.querySelector('#force-update-btn')) {
      ta.insertBefore(btn, ta.firstChild);
      return true;
    }
    return false;
  };
  if (!mount()) {
    // Fallback: body fixed (khi chưa render topbar, vd trang login).
    const tryBody = () => { if (mount()) return; window.setTimeout(tryBody, 500); };
    tryBody();
  }
  // Chỉ hiện nút khi CÓ bản mới chờ activate (updatefound→installed) — bình thường ẩn, k che mobile.
  const show = () => { if (btn.style.display !== 'inline-flex') btn.style.display = 'inline-flex'; };
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => {
        r.addEventListener?.('updatefound', () => {
          const nw = r.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) show();
          });
        });
      });
    });
  }
  // Phím: Ctrl+Shift+U → mở nút (force manual)
  window.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.shiftKey && (e.key === 'u' || e.key === 'U')) { e.preventDefault(); show(); }
  });
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ToastContainer />
      <CommandPalette />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="*"
          element={
            <App>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/expenses" element={<Navigate to="/finance/expenses" replace />} />
                <Route path="/payables" element={<Navigate to="/finance/payables" replace />} />
                <Route path="/finance/backfill" element={<Navigate to="/warehouse/backfill" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/orders/:id" element={<OrderDetailPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/sales-history" element={<SalesHistoryPage />} />
                <Route path="/inventory" element={<InventoryPage />} />
                <Route path="/tax/report" element={<TaxReportPage />} />
                <Route
                  path="/warehouse/import"
                  element={<Navigate to="/warehouse/import-vn" replace />}
                />
                <Route path="/warehouse/import-vn" element={<ImportVnPage />} />
                <Route
                  path="/tax/imported-view"
                  element={
                    <ImportOrderPage
                      allowedGoodsTypes={["bangke", "vat"]}
                      lockGoodsType
                      readOnly
                      panelTitle="Hàng đã nhập (đối chiếu thuế)"
                      panelDescription="Xem các đơn nhập VN/bảng kê/VAT đã ghi — để đối chiếu khai thuế. Chỉ xem."
                    />
                  }
                />
                <Route path="/tax/import-vn" element={<Navigate to="/warehouse/import-vn" replace />} />
                <Route path="/warehouse/virtual" element={<VirtualInventoryPage />} />
                <Route path="/finance/payables" element={<PayablesPage />} />
                <Route path="/finance/expenses" element={<ExpensesPage />} />
                <Route path="/inventory/take" element={<StockTakePage />} />
                <Route path="/ops/pos" element={<Suspense fallback={<div>Đang tải...</div>}><PosPage /></Suspense>} />
                <Route path="/ops/barcode" element={<Suspense fallback={<div>Đang tải...</div>}><BarcodePrintPage /></Suspense>} />
                <Route path="/ops/admin" element={<AdminToolsPage />} />
                <Route path="/tax/purchase-ledger" element={<PurchaseLedgerPage />} />
                <Route path="/finance/pnl" element={<PnLReportPage />} />
                <Route path="/finance/revenue" element={<Navigate to="/" replace />} />
                <Route path="/ops/todos" element={<NeedsCompletionPage />} />
                <Route path="/warehouse/consignment" element={<ConsignmentPage />} />
                {/* Đối soát ký gửi đã gộp vào trang Hàng ký gửi — redirect link cũ */}
                <Route path="/finance/consignment-report" element={<Navigate to="/warehouse/consignment" replace />} />
                <Route path="/ops/backup" element={<BackupPage />} />
                <Route path="/ops/assets" element={<AssetsPage />} />
                <Route path="/warehouse/backfill" element={<BackfillPage />} />
                <Route path="/warehouse/allocation" element={<InventoryAllocationPage />} />
                <Route path="/inventory/alerts" element={<StockAlertsPage />} />
                <Route path="/inventory/abc-analysis" element={<ABCAnalysisPage />} />
                <Route path="/inventory/predictive-restock" element={<PredictiveRestockPage />} />
                <Route path="/finance/suppliers" element={<SuppliersPage />} />
                <Route path="/ops/ai-config" element={<AIConfigPage />} />
                <Route path="/tax/center" element={<TaxCenterPage />} />
                <Route path="/warehouse/materials" element={<MaterialsPage />} />
                <Route path="/ops/bank-notifications" element={<BankNotificationsPage />} />
              </Routes>
            </App>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

